import { render, staticRenderFns } from "./SidebarBlock.vue?vue&type=template&id=6304ff72&scoped=true&"
import script from "./SidebarBlock.vue?vue&type=script&lang=js&"
export * from "./SidebarBlock.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBlock.vue?vue&type=style&index=0&id=6304ff72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6304ff72",
  null
  
)

export default component.exports